import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollsCartridge } from "./components/RollsCartridge";

export const RollsCartridgePage = () => {
	return (
		<>
			<HelmetDexteel title="Rolls Cartridge" />
			<RollsCartridge />
		</>
	);
};
